import { action, makeObservable, observable } from 'mobx';

export default class CommonStore {
  testCount: number;

  another: number;

  constructor() {
    this.testCount = 0;
    this.another = 1;
    makeObservable(this, {
      testCount: observable,
      another: observable,
      myIncrease: action,
      timezone: observable,
      zones: observable,
      timeFormat: observable,
      shortTimeFormat: observable,
    });
  }

  timezone: string = process.env.REACT_APP_TIME_ZONE || 'America/Los_Angeles';

  zones = {
    PST: {
      posfix: 'PST',
      value: -8,
    },
    NOPST: {
      posfix: '',
      value: -8,
    },
  };

  timeFormat = 'MM/DD/YYYY HH:mm';
  shortTimeFormat = 'DD MMM YYYY';

  myIncrease = () => {
    this.testCount++;
    this.another++;
  };
}
